import ContractServices from "@/services/ContractServices";
import FileServices from "@/services/FileServices";

const types = {
  GET_CONTRACT: '@CONTRACT/GET_CONTRACT',
  GET_CONTRACT_MONTH: '@CONTRACT/GET_CONTRACT_MONTH',
  GET_CONTRACT_SUMMARY: '@CONTRACT/GET_CONTRACT_SUMMARY',
  GET_CONTRACT_PAGE: '@CONTRACT/GET_CONTRACT_PAGE',
  GET_CONTRACT_CHART: '@CONTRACT/GET_CONTRACT_CHART',
  GET_CONTRACT_FILTER: '@CONTRACT/GET_CONTRACT_FILTER',
  GET_CONTRACT_DETAIL: '@CONTRACT/GET_CONTRACT_DETAIL',
  GET_CONTRACT_DATE_LIST: '@CONTRACT/GET_CONTRACT_DATE_LIST',
  GET_CONTRACT_PRODUCT_LIST: '@CONTRACT/GET_CONTRACT_PRODUCT_LIST',
  GET_CONTRACT_DETAIL_CHART: '@CONTRACT/GET_CONTRACT_DETAIL_CHART',
  GET_CONTRACT_DETAIL_FILTER: '@CONTRACT/GET_CONTRACT_DETAIL_FILTER',
  GET_CONTRACT_SEARCH: '@CONTRACT/GET_CONTRACT_SEARCH',
  GET_CSP_ACCOUNT_INFO_LIST: '@CONTRACT/GET_CSP_ACCOUNT_INFO_LIST'

}

export {
  types as contractTypes
}

export default {
  namespaced: true,
  state: {
    cspAccountList: [],
    contracts: [],
    contractMonth: [],
    contractSummary: {
      totalCost : 0,
      invoiceMonth : ''
    },
    contractSearch: {
      loaded: false
      , pageNo: 1
      , searchText: ''
      , category: 'all'
      , pageSize: 20
      , startMonth: ''
      , endMonth: ''
    },
    pagingDTO : {
      pageNo : 0,
      size : 20,
      startIndex : 0,
      totalCount : 0
    },
    contractChartData: [],
    contractSeriesList: [],
    contractDetail: {},
    dateList : [],
    products:[],
    date : '',
    contractDetailChartData: [],
    contractDetailSeriesList: [],
    userInfo: {}
  },

  getters: {
    cspAccountList(state) {
      return state.cspAccountList
    },
    contractSearch (state) {
      return state.contractSearch
    },
    contracts (state) {
      return state.contracts;
    },
    contractSummary: (state) => {
      return state.contractSummary;
    },
    contractMonth: (state) => {
      return state.contractMonth;
    },
    pagingDTO: (state) => {
      return state.pagingDTO;
    },
    contractChartData: (state) => {
      return state.contractChartData;
    },
    contractSeriesList: (state) => {
      return state.contractSeriesList;
    },
    contractDetail: (state) => {
      return state.contractDetail;
    },
    dateList: (state) => {
      return state.dateList;
    },
    productList: (state) => {
      return state.products;
    },
    contractDetailChartData: (state) => {
      return state.contractDetailChartData;
    },
    contractDetailSeriesList: (state) => {
      return state.contractDetailSeriesList;
    },

  },

  mutations: {
    [types.GET_CSP_ACCOUNT_INFO_LIST] (state, payload) {
      state.cspAccountList = payload.cspAccountList;
    },
    [types.GET_CONTRACT_SEARCH] (state, payload) {
      state.contractSearch = payload.contractSearch;
    },
    [types.GET_CONTRACT] (state, payload) {
      state.contracts = payload.contracts;
    },
    [types.GET_CONTRACT_MONTH] (state, payload) {
      state.contractMonth = payload.contractMonth;
    },
    [types.GET_CONTRACT_SUMMARY] (state, payload) {
      state.contractSummary = payload.contractSummary;
    },
    [types.GET_CONTRACT_PAGE] (state, payload) {
      state.pagingDTO = payload.pagingDTO;
    },
    [types.GET_CONTRACT_CHART] (state, payload) {
      state.contractChartData = payload.contractChartData;
    },
    [types.GET_CONTRACT_FILTER] (state, payload) {
      state.contractSeriesList = payload.contractSeriesList;
    },
    [types.GET_CONTRACT_DETAIL] (state, payload) {
      state.contractDetail = payload.contractDetail
    },
    [types.GET_CONTRACT_DETAIL] (state, payload) {
      state.contractDetail = payload.contractDetail
    },
    [types.GET_CONTRACT_DATE_LIST] (state, payload) {
      state.dateList = payload.dateList
    },
    [types.GET_CONTRACT_PRODUCT_LIST] (state, payload) {
      state.products = payload.products
    },

    [types.GET_CONTRACT_DETAIL_CHART] (state, payload) {
      state.contractDetailChartData = payload.contractDetailChartData
    },
    [types.GET_CONTRACT_DETAIL_FILTER] (state, payload) {
      state.contractDetailSeriesList = payload.contractDetailSeriesList
    },

  },

  actions: {
    async getCSPAccountId({commit}, payload){
      commit(types.GET_CSP_ACCOUNT_INFO_LIST, { cspAccountList: []});
      const {companyCode, id, month, prodId} = payload
      if( prodId !== '' && prodId !== undefined) {
        const response = await ContractServices.getCSPAccountId({companyCode, id, month, prodId})
        let i = 1
        response.data.resultData.forEach(item => {
          item.rowId = i
          i++
        })
        commit(types.GET_CSP_ACCOUNT_INFO_LIST, { cspAccountList: response.data.resultData});
      }
    },
    setContractSearch( {commit}, payload) {
      commit(types.GET_CONTRACT_SEARCH, { contractSearch: payload })
    },
    async getContract ({dispatch, rootGetters}, payload) {
      const userInfo = rootGetters['user/userInfo']
      if (userInfo.auth === 'AM') {
        await dispatch('getCustomerContracts', payload)
      }else{
        await dispatch('getContracts',payload)

      }
    },

    async getContractChartData ({dispatch, rootGetters}, payload) {
      const userInfo = rootGetters['user/userInfo']
      if (userInfo.auth === 'AM') {
        await dispatch('getContractsGetCustomerChartData', payload)
      }else{
        await dispatch('getContractsGetChartData',payload)
      }
    },


    async getContracts ({commit}, payload) {
      const { companyCode, empNo, month, pageNo, size ,searchText,jobTitleCode,empAuthDept,orderCol, desc, category, startMonth, endMonth } = payload
      const response = await ContractServices.getContracts({
        companyCode, empNo, month, pageNo, size,searchText,jobTitleCode,empAuthDept,orderCol, desc, category, startMonth, endMonth
      })

      commit(types.GET_CONTRACT, { contracts: response.data.resultData.contracts});
      commit(types.GET_CONTRACT_MONTH, { contractMonth: response.data.resultData.contract });
      commit(types.GET_CONTRACT_SUMMARY, { contractSummary: response.data.resultData.contractDetail });
      commit(types.GET_CONTRACT_PAGE, { pagingDTO: response.data.resultData.pagingDTO });

      return response.data.resultData;
    },
    async getContractsGetChartData({commit},payload) {
      const { companyCode, empNo, endMonth, startMonth ,jobTitleCode,empAuthDept} = payload
      const response = await ContractServices.getContractsGetChartData({
        companyCode, empNo, endMonth, startMonth,jobTitleCode,empAuthDept
      })
      commit(types.GET_CONTRACT_CHART, { contractChartData: response.data.resultData.chartData});
      commit(types.GET_CONTRACT_FILTER, { contractSeriesList: response.data.resultData.filter});

      return response.data.resultData;
    },

    async getContractsWithId({commit},payload) {
      const { companyCode, id, month,empNo } = payload
      const response = await ContractServices.getContractsWithId({
        companyCode, id, month,empNo
      })

      commit(types.GET_CONTRACT_DETAIL, { contractDetail: response.data.resultData});
      commit(types.GET_CONTRACT_DATE_LIST, { dateList: response.data.resultData.dateList});

      return response.data.resultData;
    },


    async getContractsProductsWithId ({commit},payload) {

      const { companyCode, id, month } = payload

      const response = await ContractServices.getContractsProductsWithId({
        companyCode, id, month
      })

      commit(types.GET_CONTRACT_PRODUCT_LIST, { products: response.data.resultData.products});

      return response.data.resultData;
    },

    async getContractsGetChartDataWithId ({commit},payload) {

      const { id, companyCode, empNo, endMonth, startMonth } = payload

      const response = await ContractServices.getContractsGetChartDataWithId({
        id, companyCode, empNo, endMonth, startMonth
      })

      commit(types.GET_CONTRACT_DETAIL_CHART, { contractDetailChartData: response.data.resultData.chartData});
      commit(types.GET_CONTRACT_DETAIL_FILTER, { contractDetailSeriesList: response.data.resultData.filter});

      return response.data.resultData;
    },
    async getCustomerContracts ({commit}, payload) {
      const { companyCode, empNo, month, pageNo, size ,searchText,customerCode, deptCode,orderCol, desc, category, startMonth, endMonth} = payload
      const response = await ContractServices.getCustomersDeptsContactsWithCustomerCodeAndDepthCode({
        companyCode, empNo, month, pageNo, size,searchText,customerCode, deptCode,orderCol, desc, category, startMonth, endMonth
      })
      commit(types.GET_CONTRACT, { contracts: response.data.resultData.contracts});
      commit(types.GET_CONTRACT_MONTH, { contractMonth: response.data.resultData.contract });
      commit(types.GET_CONTRACT_SUMMARY, { contractSummary: response.data.resultData.contractDetail });
      commit(types.GET_CONTRACT_PAGE, { pagingDTO: response.data.resultData.pagingDTO });

      return response.data.resultData;
    },



    async getContractsGetCustomerChartData({commit},payload) {

      const { companyCode, empNo, endMonth, startMonth ,customerCode, deptCode} = payload
      const response = await ContractServices.getContractsGetCustomerChartData({
        companyCode, empNo, endMonth, startMonth,customerCode, deptCode
      })


      commit(types.GET_CONTRACT_CHART, { contractChartData: response.data.resultData.chartData});
      commit(types.GET_CONTRACT_FILTER, { contractSeriesList: response.data.resultData.filter});

      return response.data.resultData;
    },
    async getCSVDownLoad({commit}, payload){
      await FileServices.getCSVFile(payload)
    }
  }
}




// WEBPACK FOOTER //
// ./src/store/modules/contract.js